// @ts-nocheck
import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import {
    Container,
    Typography,
    Box,
    Modal,
    List,
    ListItemText,
    Divider,
    Button,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    useMediaQuery,
    CircularProgress,
    LinearProgress,
    useTheme,
    Grid,
    Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDifusiones } from "./context/DifusionesContext";
import { useBody } from '../Body/state/BodyContext';
import { useAuth } from "../Auth/State/AuthContext";
import FileCard from "./Componentes/agregar-difusion/redactar-mail/FileCard";
import BuscarDestinatarios from './Componentes/ver-difusion/BuscarDestinatarios';
import CancelarProgramacionModal from './Componentes/ver-difusion/CancelarProgramacionModal';
import DifusionChip from './Componentes/DifusionChip';

export const VerDifusion = ({ onClose, difusion }) => {
    const { obtenerDifusion, obtenerDifusionesByAreas, eliminarDifusion, alcanzoLimiteAlias, areasUser } = useDifusiones();
    const { setMessage, setSuccess } = useBody();
    const { hasRole } = useAuth();
    const [difusionSeleccionada, setDifusionSeleccionada] = useState({});
    const [continuaEnvio, setContinuaEnvio] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [open, setOpen] = useState(false);
    const [openCancelar, setOpenCancelar] = useState(false);
    const [progress, setProgress] = useState(0);
    const [diferenciaMeses, setDiferenciaMeses] = useState(0);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));
    const colors = {
        "1": "primary",
        "2": "error",
        "3": "primary",
        "4": "success",
        "5": "primary"
    }

    useEffect(() => {
        if (difusionSeleccionada.destinatarios?.length) {
            const total = difusionSeleccionada.destinatarios.length;
            setProgress((difusionSeleccionada.recuentoAperturas * 100) / total);
        }
        if (difusionSeleccionada.horaEmision) {
            const now = new Date();
            const difusionFecha = new Date(difusionSeleccionada.horaEmision);
            let diferencia = (now.getFullYear() - difusionFecha.getFullYear()) * 12 + (now.getMonth() - difusionFecha.getMonth());
            if (now.getDate() < difusionFecha.getDate()) diferencia -= 1;
            setDiferenciaMeses(diferencia);
        }
    }, [difusionSeleccionada]);

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    useEffect(() => {
        const fetchDifusion = async () => {
            setLoading(true);
            try {
                const difusionData = await obtenerDifusion(difusion.uid);
                setDifusionSeleccionada(difusionData);
                const limiteAlias = await alcanzoLimiteAlias(difusionData.remitente);
                setContinuaEnvio(limiteAlias);

            } catch (error) {
                setError(true);
                setMessage("Hubo un error al obtener la difusión");
                console.error("Error al obtener difusión:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDifusion();
    }, [difusion]);

    const handleDelete = async () => {
        setLoading(true);
        try {
            await eliminarDifusion(difusionSeleccionada.id);
            setSuccess("La difusión ha sido cancelada");
            obtenerDifusionesByAreas(areasUser);
            onClose();
        } catch (error) {
            setMessage("Hubo un error al intentar cancelar la difusión");
            console.error("Error al cancelar la difusión:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {loading ? (
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 30, gap: 3 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 10 }}>
                    No se pudo cargar la difusión. Por favor intentá de nuevo más tarde.
                </Box>
            ) : (
                <Box display="flex" flexDirection="column" gap={2}>
                    {!continuaEnvio && ["Enviando", "Envio Demorado"].includes(difusionSeleccionada.estado) ?
                        <Alert severity="info">
                            Actualmente el alias remitente <b>{difusionSeleccionada.remitente}</b> alcanzó el límite de envíos diarios, por lo que no se continuará con el envío hasta dentro de 24hs.
                        </Alert>
                        :
                        null
                    }

                    <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={3}>

                        <Box flex={1}>
                            <List>
                                <DifusionChip estado={difusionSeleccionada.estado} />

                                <Box my={3}>
                                    <Box mb={1}>
                                        <Typography variant="subtitle1">
                                            <Typography component="span" fontWeight="bold">
                                                Asunto:
                                            </Typography>{" "}
                                            {difusionSeleccionada.asunto}
                                        </Typography>
                                    </Box>

                                    <Box mb={1}>
                                        <Typography variant="subtitle1">
                                            <Typography component="span" fontWeight="bold">
                                                Remitente:
                                            </Typography>{" "}
                                            {difusionSeleccionada.remitente}
                                        </Typography>
                                    </Box>

                                    <Box mb={1}>
                                        <Typography variant="subtitle1">
                                            <Typography component="span" fontWeight="bold">
                                                Enviada por:
                                            </Typography>{" "}
                                            {difusionSeleccionada.usuario}
                                        </Typography>
                                    </Box>

                                    <Box mb={1}>
                                        <Typography variant="subtitle1">
                                            <Typography component="span" fontWeight="bold">
                                                Área:
                                            </Typography>{" "}
                                            {areasUser.find(a => a.id === difusionSeleccionada.area)?.name ?? difusionSeleccionada.areaNombre}
                                        </Typography>
                                    </Box>

                                    <Box mb={1}>
                                        <Typography variant="subtitle1">
                                            <Typography component="span" fontWeight="bold">
                                                {difusionSeleccionada.horaEntregaProgramada ? "Hora de envío programado:" : "Hora de envío:"}
                                            </Typography>{" "}
                                            {difusionSeleccionada.horaEntregaProgramada || difusionSeleccionada.horaEmision}
                                        </Typography>
                                    </Box>

                                    <Box mb={1}>
                                        <Typography variant="subtitle1">
                                            <Typography component="span" fontWeight="bold">
                                                Identificador de la difusión:
                                            </Typography>{" "}
                                            {difusionSeleccionada.uid || ""}
                                        </Typography>
                                    </Box>

                                    {["Enviado", "Envio Parcial"].includes(difusionSeleccionada.estado) && diferenciaMeses < 1 && (
                                        <Box mb={1}>
                                            <Typography component="span" fontWeight="bold">
                                                Porcentaje de visualización:
                                            </Typography>
                                            <Box sx={{ width: "100%", mt: 1, mb: 0.5 }}>
                                                <LinearProgress variant="determinate" value={progress} />
                                            </Box>
                                            <Typography variant="subtitle1">
                                                {difusionSeleccionada.recuentoAperturas} de{" "}
                                                {difusionSeleccionada.destinatarios.length} personas han visto la difusión.
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                                {["Enviado", "Envio Parcial"].includes(difusionSeleccionada.estado) && (
                                    <Dialog
                                        open={open}
                                        onClose={handleClose}
                                        maxWidth="md"
                                        fullWidth
                                        scroll="paper"
                                    >
                                        <DialogTitle sx={{ pr: 6 }}>
                                            Destinatarios
                                            <IconButton
                                                onClick={handleClose}
                                                size="small"
                                                sx={{ position: 'absolute', right: 12, top: 12 }}
                                            >
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </DialogTitle>
                                        <DialogContent dividers sx={{ minHeight: 650 }}>
                                            <BuscarDestinatarios
                                                destinatarios={difusionSeleccionada.destinatarios}
                                                difusionDate={difusionSeleccionada.horaEmision}
                                                difusionId={difusionSeleccionada.uid}
                                            />
                                        </DialogContent>
                                    </Dialog>
                                )}
                                <Typography variant="subtitle1" gutterBottom>
                                    <Typography component="span" fontWeight="bold">
                                        Listas Destinatarias:
                                    </Typography>
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
                                    {difusionSeleccionada.nombresListas.map((lista, i) => (
                                        <Chip
                                            key={i}
                                            label={lista.nombre}
                                            variant="outlined"
                                            color={lista.eliminada ? "error" : "default"}
                                            title={lista.eliminada ? "Esta lista fue eliminada" : undefined}
                                        />
                                    ))}
                                </Box>
                            </List>
                        </Box>

                        <Box flexShrink={0} alignSelf={{ xs: 'center', md: 'flex-start' }}>
                            {["Enviado", "Envio Parcial"].includes(difusionSeleccionada.estado) && (
                                <Button sx={{ textTransform: 'none' }} variant="contained" color="primary" onClick={handleOpen} >
                                    Ver destinatarios
                                </Button>
                            )}
                        </Box>
                    </Box>

                    <Divider sx={{ my: 2 }}>
                        <Typography variant="caption" color="text.secondary">Contenido del mensaje</Typography>
                    </Divider>

                    <Box sx={{ overflowWrap: 'break-word', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(difusionSeleccionada.cuerpo_mail) }} />

                    {difusionSeleccionada.archivos?.length > 0 && (
                        <>
                            <Divider sx={{ my: 2 }}>
                                <Typography variant="caption" color="text.secondary">
                                    Archivos adjuntos
                                </Typography>
                            </Divider>

                            <Box
                                component="ul"
                                display="flex"
                                flexWrap="wrap"
                                gap={2}
                                p={0}
                                mt={0}
                                mb={3}
                            >
                                {difusionSeleccionada.archivos.map(file => (
                                    <FileCard
                                        key={file.nombre}
                                        nombreDelArchivo={file.nombre}
                                        type={file.extension}
                                    />
                                ))}
                            </Box>
                        </>
                    )}


                    {difusionSeleccionada.estado === 'Envio Programado' && hasRole(["ROLE_CANCELAR_ENVIO_DIFUSION"]) && (
                        <>
                            <Divider sx={{ my: 2 }} />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    sx={{ textTransform: 'none' }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setOpenCancelar(true)}
                                >
                                    Cancelar Programación
                                </Button>
                                <CancelarProgramacionModal
                                    open={openCancelar}
                                    onClose={() => setOpenCancelar(false)}
                                    handleDelete={handleDelete}
                                />
                            </Box>
                        </>
                    )}
                </Box>

            )}
        </>
    );
};
